<mibp-dialog #dialog [buttons]="dialogButtons" titleResourceStringKey="Timeout_Title" resourceStringKey="Timeout_Description" resourceStringKeyIsHtml="true" (closed)="reset()" (buttonClick)="dialogClick($event)" size = "auto">
    <p class="session-timeout-class">{{idleCountDown*1000| date:'mm:ss':'UTC'}}</p>
</mibp-dialog>
